import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { zonedTimeToUtc } from 'date-fns-tz';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IUser } from 'src/app/commons/interfaces/user.interface';
import { IEnrollmentResponse } from 'src/app/views/enrollment/commons/interfaces/enrollment-response.interface';
import { environment } from 'src/environments/environment';
import { StorageKeysEnum } from '../config/storage-keys.enum';
import { SessionHandlerService } from '../services/session-handler.service';

const apiUrl = environment.apiUrl;

@Injectable()
export class UserHttp {
  constructor(private http: HttpClient, private session: SessionHandlerService) { }
  /**
   *
   * @returns Observable of user http response
   */
  getUser(): Observable<IUser> {
    const auth = this.session.getAuthToken();
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', `${auth.token_type} ${ auth.access_token }`);
    return this.http.get<IUser>(apiUrl + 'api/user', { headers }).pipe(
      map((user: IUser) => {
        this.saveUser(user);
        return user;
      })
    );
  }
  /**
   * saveUser
   *
   * @description store de user in sessionStorage
   *
   * @param user user object
   */
  private saveUser(user: IUser): void {

    (user as any).enrollments = 'enrollments' in user ? this.formatEnrollmentAvailability((user as any).enrollments) : [];
    this.session.setUser(user);
  }
  private formatEnrollmentAvailability(enrollments: any[]) {

    return enrollments.map(e => ({
      ...e,
      enabled_from: zonedTimeToUtc(e.enabled_from, 'America/Lima'),
      enabled_to: zonedTimeToUtc(e.enabled_to, 'America/Lima')
    }))
  }
}
